export default class QuestionNode {
    constructor(question, answerFilterFn = null) {
        this.question = question;
        this.next = null;
        this.prev = null;
        this.answerFilterFn = answerFilterFn;
        this.results = [];
    }

    getQuestion() {
        return this.question;
    }

    getId() {
        return this.question.getId();
    }

    getAnswers() {
        let _answers = this.question.getAnswers();
        if (this.answerFilterFn !== null && typeof this.answerFilterFn === 'function') {
            _answers = _answers.filter(this.answerFilterFn, this);
        }
        return _answers;
    }

    setResult(id) {
        id = this._sanitizeResults(id);
        this.results = [this._getAnswerById(id)];
    }

    setResults(ids) {
        ids = this._sanitizeResults(ids);
        this.results = [];
        for (const id of ids) {
            this.results.push(this._getAnswerById(id));
        }
    }

    clearResults() {
        this.results = [];
    }

    getResults() {
        return this.results;
    }

    hasResult(id) {
        return this.results.filter(function(r) {
            return r.id === id;
        }).length > 0;
    }

    _getAnswerById(id) {
        const _answers = this.getAnswers();

        for (const answer of _answers) {
            if (answer.id === id) {
                return answer;
            }
        }

        throw new ReferenceError('The answer is invalid.');
    }

    _sanitizeResults(results) {
        if (!Array.isArray(results)) {
            if (typeof results === 'string' || typeof results === 'number') {
                results = [results];
            } else {
                throw new TypeError('The result must be an array, string or integer.');
            }
        }

        return results;
    }

    getNext() {
        return this.next;
    }

    getPrevious() {
        return this.prev;
    }
}